import React, { useMemo } from "react";
import { Row, Col } from 'reactstrap';
import ErrorBoundary from "../../Components/Common/ErrorBoundary";
import TableContainer1 from "../../Components/Common/DataTables/TableContainer1";
const PreviousOrders = ({ previousorderdata }) => {
    const columns = useMemo(() => [
        {
            header: "Order id",
            accessorKey: "orderid",
            enableSorting: true,
            enableColumnFilter: false,
        },
        {
            header: "Ref.Id",
            accessorKey: "order_ref_code",
            enableSorting: true,
            enableColumnFilter: false,
        },
        {
            header: "Date",
            accessorKey: "order_date",
            enableSorting: true,
            enableColumnFilter: false,
        },

        {
            header: "Order Status",
            accessorKey: "status",
            enableSorting: true,
            enableColumnFilter: false,
        },
    ], []);

    return (
        <div>
            <ErrorBoundary fallback={<div>Oops! Something went wrong </div>}>
                <TableContainer1
                    columns={columns || []}
                    data={previousorderdata?.previous_orders || []}
                    customPageSize={process.env.REACT_APP_PER_PAGE}
                    total={0}
                    disableSearch={true}
                    disableNavigation={true}
                    SearchPlaceholder='Search...'
                />
            </ErrorBoundary>
        </div>
    )
}
export default React.memo(PreviousOrders);